interface Props {
  onClick: () => void;
  small?: boolean;
  active: boolean;
}
const SvgEditNote: React.FC<Props> = ({ onClick, small = false, active }) => {
  return (
    <svg
      onClick={onClick}
      style={{ transform: small ? "" : "scale(1.33,1.33)", cursor: "pointer" }}
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_15267_16080)">
        <path
          d="M3.9375 2.25C3.01219 2.25 2.25 3.01219 2.25 3.9375V14.0625C2.25 14.9878 3.01219 15.75 3.9375 15.75H10.5V12.1875C10.5 11.2487 11.2487 10.5 12.1875 10.5H15.75V3.9375C15.75 3.01219 14.9878 2.25 14.0625 2.25H3.9375ZM5.8125 5.24927H12.1875C12.498 5.24927 12.75 5.50127 12.75 5.81177C12.75 6.12227 12.498 6.37427 12.1875 6.37427H5.8125C5.502 6.37427 5.25 6.12227 5.25 5.81177C5.25 5.50127 5.502 5.24927 5.8125 5.24927ZM5.8125 7.87427H10.6875C10.998 7.87427 11.25 8.12627 11.25 8.43677C11.25 8.74727 10.998 8.99927 10.6875 8.99927H5.8125C5.502 8.99927 5.25 8.74727 5.25 8.43677C5.25 8.12627 5.502 7.87427 5.8125 7.87427ZM12.375 11.625C11.9606 11.625 11.625 11.9606 11.625 12.375V15.4197L15.4197 11.625H12.375Z"
          className={`${active ? "fill-primary" : "fill-gray3"}`}
        />
      </g>
      <defs>
        <clipPath id="clip0_15267_16080">
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SvgEditNote;
